import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import styled from 'styled-components';
import Routes from '../../router';
import utils from '@/utils/auth';

const { Sider } = Layout;
const Wrapper = styled.div`
  .ant-layout-sider {
    height: 100vh;
  }
  .logo {
    margin: 16px;
    height: 32px;
    line-height: 32px;
    color: #ffffff;
    text-align: center;
    font-weight: bold;
    background: rgba(255, 255, 255, 0.2);
  }
`;

class Sidebar extends Component {

  onMenuChange = ({ key }) => {
    this.props.history.push(key);
  }

  render() {
    const { pathNameAndPermissionName, getPermission } = utils;
    let menus = getPermission().map(o => {
      const [menu] = o.split(':');
      return menu;
    });
    const menuName = Array.from(new Set(menus));
    const routerPathList = pathNameAndPermissionName.filter(o => {
      const { value } = o;
      return menuName.includes(value);
    }).map(o => o.path);

    const newRoutes = Routes.filter(o => {
      const { path } = o;
      return routerPathList.includes(path);
    });

    const menuList = newRoutes.map((o, index) => {
      const { icon, label, path } = o;
      return {
        label,
        icon,
        key: path,
      };
    });

    const { location } = this.props.history;
    const { pathname } = location;
    const selectedKeys = [pathname];

    return (
      <Wrapper>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
        >
          <div className="logo">美团预约管理后台</div>
          <Menu
            theme="dark"
            mode="inline"
            items={menuList}
            selectedKeys={selectedKeys}
            onClick={this.onMenuChange}
          />
        </Sider>
      </Wrapper>
    );
  }
}

export default withRouter(Sidebar);
